(function () {
    'use strict';

    angular.module('Services').factory('PopLockerService', PopLockerService);
    PopLockerService.$inject = ['Request'];

    function PopLockerService(Request) {
        return {
            getAll: function (successCallback, errorCallback, data) {
                Request.get({
                    url: ApiURLs.carrier.lockerProvider,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: data
                });
            },
            details: function (id, successCallback, errorCallback) {
                Request.get({
                    url: ApiURLs.carrier.lockerProviderDetails.replace(':id', id),
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                });
            },
            updateById: function (id, successCallback, errorCallback, data) {
                const url = ApiURLs.carrier.lockerProviderDetails.replace(":id", id);
                Request.post({
                    url: url,
                    method: 'PUT',
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                }, data)
            },
            delete: function (ids, successCallback, errorCallback) {
                Request.delete({
                    url: ApiURLs.carrier.lockerProvider,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                }, ids);
            },
            createProvider: function (data, successCallback, errorCallback) {
                Request.post({
                    url: ApiURLs.carrier.lockerProviderDetails,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                }, data)
            },
            payloadMapper: function (data) {
                return {
                    active: data.active,
                    id: data.id,
                    order: data.order,
                    locationIds: data.locationIds || [],
                    providerName: data.providerName
                };
            },
            payloadLocation: function (data) {
                return [
                    {
                        active: data.active,
                        addressLine1: data.addressLine1,
                        addressLine2: data.addressLine2,
                        id: data.id,
                        locationId: data.locationId,
                        locationName: data.locationName,
                        lockerId: data.lockerId,
                        lockerLocationType: data.lockerLocationType,
                        operatingHours: operatingHours(data.operation)
                    }
                ]

                function operatingHours(operation) {

                    return [{
                        endDay: "sunday",
                        endTime: "string",
                        startDay: "sunday",
                        startTime: "string"
                    }];
                }
            },
            getLocation: function (successCallback, errorCallback, data) {
                Request.get({
                    url: ApiURLs.carrier.lockerProviderLocations,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: data
                });
            },
            updateLocation: function (successCallback, errorCallback, data) {
                Request.post({
                    url: ApiURLs.carrier.lockerProviderLocations,
                    method: 'PUT',
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                }, data)
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/PopLockerService.js